export function isApiKeyExpired(apiKey) {
  try {
    const [, payload] = apiKey.split(".");
    const decoded = JSON.parse(atob(payload));
    return decoded.exp * 1000 < Date.now();
  } catch (error) {
    console.warn("[Token Check]: Invalid JWT Format", error);
    return true;
  }
}
